export const mobileAppPageBannerArabic = {
    mainHeading: "تطوير تطبيقات الهاتف",
    greenHeading: "المحمول",
    subHeading: "موثوق به من قبل الشركات الناشئة والشركات الصغيرة والمتوسطة والمؤسسات على حد سواء.",
    sectionContent: "Bitsclan IT Solutions هي شركة رائدة في تطوير تطبيقات الهاتف المحمول. نحن نبني تطبيقات جوال تتمحور حول المستخدم وعالية الأداء ومخصصة وآمنة للنجاح في سوق تنافسي.",
    buttonText: "هيا بنا نبدأ"
}

export const mobileAppDevelopmetServicesArabic = {
    sectionContent: {
        mainHeading: "مجموعتنا الواسعة من خدمات تطوير تطبيقات الهاتف المحمول الشاملة.",
        subHeading: "تغطي خدمات تطبيقات الهاتف المحمول المخصصة لدينا كل شيء، من التطبيقات الجاهزة للمستقبل المدمجة بالذكاء الاصطناعي إلى الحلول الآمنة والمخصصة. تحتاج الشركات إلى حضور على الهاتف المحمول وهنا يدخل مطورونا.",
        secondSubHeading: "من خلال خدماتنا الخالية من العيوب على مدار الساعة، يتوفر خبراؤنا لتقديم تجربة سلسة ومبتكرة لعملائك. من الفكرة إلى التسليم، يضمن مطورونا أن يكون منتجك هو النموذج الأولي الذي حلمت به بالضبط."
    },
    tabsContent: [
        {
            id: "Tab1",
            label: "تطوير تطبيقات الجوال المخصصة",
            content:
                "نقوم بتصميم وتطوير تطبيقات جوال مخصصة تتوافق تمامًا مع أهداف عملك، مما يضمن تجربة مستخدم سلسة وعالية الأداء. سواء كنت بحاجة إلى تطبيق iOS أو android أو تطبيق متعدد المنصات، يستخدم مطورونا الخبراء أحدث التقنيات لإنشاء حلول جوال قابلة للتطوير وغنية بالميزات. من الفكرة الأولية إلى النشر النهائي، نركز على إنشاء تطبيقات بديهية وجذابة وجاهزة للمستقبل.",
            secondContent: "يضمن فريقنا بناء كل تطبيق بأساس قوي، يشتمل على أمان من الدرجة الأولى ووظائف سلسة وواجهات سهلة الاستخدام. سواء كنت شركة ناشئة تبحث عن حضور مبتكر على الأجهزة المحمولة أو مؤسسة تهدف إلى تبسيط العمليات، فإننا نصمم حلولنا لتلبية احتياجاتك الخاصة. مع التركيز القوي على قابلية الاستخدام والأداء، تتميز تطبيقاتنا في السوق التنافسي، مما يضمن نجاحًا طويل الأمد لعملك.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/mobile3.png",
                },
                {
                    img: "/images/kotlin-icon.png",
                },
                {
                    img: "/images/java-icon.png",
                },
                {
                    img: "/images/object-c.png",
                },
                {
                    img: "/images/fluttre-icon.png",
                },
            ],
        },
        {
            id: "Tab2",
            label: "تطوير تطبيقات الجوال للمؤسسات",
            content:
                "للشركات التي تتطلع إلى تعزيز الإنتاجية وتحسين العمليات الداخلية، نقدم تطوير تطبيقات جوال للمؤسسات يحول العمليات ويبسط سير العمل. تم تصميم حلولنا لمواجهة التحديات الفريدة للمؤسسات الكبيرة، وتوفير تطبيقات آمنة وقابلة للتطوير وعالية الأداء تتكامل بسلاسة مع أنظمة المؤسسة الحالية.",
            secondContent: "نحن نركز على بناء حلول جوال تعمل على تحسين تعاون الفريق، وأتمتة العمليات التجارية، وتعزيز أمان البيانات مع ضمان الامتثال لمعايير الصناعة. من تكاملات تخطيط موارد المؤسسات (ERP) إلى أتمتة سير العمل المخصصة، تمكّن تطبيقات المؤسسات الخاصة بنا الشركات من الوصول إلى البيانات في الوقت الفعلي ومزامنة السحابة والتنقل المحسّن. مع الالتزام بالموثوقية والأداء، تمكّن حلول الجوال للمؤسسات الخاصة بنا المؤسسات من العمل بكفاءة أكبر في عالم رقمي سريع الخطى.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/mobile-app-development/swiftui.png",
                },
                {
                    img: "/images/services-icons/mobile-app-development/jetpack compose icon_RGB.png",
                },
                {
                    img: "/images/services-icons/mobile-app-development/Google-flutter-logo.png",
                },
            ],
        },
        {
            id: "Tab3",
            label: "تطوير تطبيقات الجوال متعددة المنصات",
            content:
                "أصبح الوصول إلى جمهور أوسع باستخدام تطبيق واحد ممكنًا الآن من خلال خدمات تطوير تطبيقات الجوال متعددة المنصات. من خلال الاستفادة من أطر عمل مثل Flutter و React Native و Xamarin، نقوم بإنشاء تطبيقات توفر تجربة تشبه التطبيقات الأصلية على كل من iOS و android مع تقليل وقت التطوير والتكاليف.",
            secondContent: "تضمن حلولنا متعددة المنصات تجربة مستخدم متسقة وأداء سلس وقابلية توسع سهلة. يمكن للشركات الاستفادة من قاعدة تعليمات برمجية واحدة مع الوصول إلى منصات متعددة دون المساومة على الجودة. سواء كنت تبحث عن بناء منصة للتجارة الإلكترونية، أو تطبيق شبكة اجتماعية، أو حل للتنقل للمؤسسات، فإن نهجنا متعدد المنصات يضمن فعالية التكلفة، والنشر الأسرع، وسهولة الصيانة المحسنة.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/mobile-app-development/swiftui.png",
                },
                {
                    img: "/images/services-icons/mobile-app-development/jetpack compose icon_RGB.png",
                },
                {
                    img: "/images/services-icons/mobile-app-development/Google-flutter-logo.png",
                },
            ],
        },
        {
            id: "Tab4",
            label: "تصميم واجهة المستخدم/تجربة المستخدم لتطبيقات الجوال",
            content:
                "الواجهة الجذابة بصريًا وسهلة الاستخدام هي مفتاح نجاح التطبيق. تركز خدمات تصميم واجهة المستخدم/تجربة المستخدم لدينا على صياغة واجهات جوال مذهلة وبديهية وجذابة ترفع تجربة المستخدم. نحن نستخدم استراتيجيات تصميم تعتمد على البيانات، واختبار قابلية الاستخدام، وبحث شامل للمستخدم لإنشاء تطبيقات ليست فقط ممتعة من الناحية الجمالية ولكنها أيضًا وظيفية للغاية.",
            secondContent: "من التنقل السلس إلى التفاعلات السلسة، يضمن فريق التصميم لدينا تحسين كل جانب من جوانب تطبيقك للمشاركة والاحتفاظ بالمستخدم. نعطي الأولوية للتصاميم المتجاوبة، مما يضمن أن تطبيقك يوفر تجربة خالية من العيوب عبر أحجام الشاشات والأجهزة المختلفة. من خلال الجمع بين الابتكار والتصميم المرتكز على المستخدم، نقوم بإنشاء تجارب رقمية تجذب المستخدمين وتعزز ولاء العلامة التجارية.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/mobile-app-development/swiftui.png",
                },
                {
                    img: "/images/services-icons/mobile-app-development/jetpack compose icon_RGB.png",
                },
                {
                    img: "/images/services-icons/mobile-app-development/Google-flutter-logo.png",
                },
            ],
        },
        {
            id: "Tab5",
            label: "استشارات تطبيقات الجوال",
            content:
                "إذا كان لديك فكرة تطبيق ولكنك غير متأكد من كيفية إحيائها، فإن خدمات استشارات تطبيقات الجوال لدينا توفر التوجيه الذي تحتاجه. نساعد الشركات على تحسين مفاهيمها، واختيار حزمة التقنيات المناسبة، وتحديد خارطة طريق تطوير فعالة. يحلل خبراؤنا اتجاهات السوق، وسلوك المستخدم، والمشهد التنافسي لوضع استراتيجية قوية تضمن نجاح تطبيقك.",
            secondContent: "من تخطيط الميزات واستراتيجيات تحقيق الدخل إلى قابلية التوسع وتحسين الأداء، نساعدك على تجنب الأخطاء الشائعة واتخاذ قرارات مستنيرة. سواء كنت بحاجة إلى مساعدة في الاختيار بين تطوير التطبيقات الأصلية أو متعددة المنصات، أو تحسين تجربة المستخدم، أو ضمان الاستدامة طويلة الأمد، فإن خدمات الاستشارات لدينا تمكّنك من خلال رؤى الخبراء والحلول العملية.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/mobile-app-development/swiftui.png",
                },
                {
                    img: "/images/services-icons/mobile-app-development/jetpack compose icon_RGB.png",
                },
                {
                    img: "/images/services-icons/mobile-app-development/Google-flutter-logo.png",
                },
            ],
        },
        {
            id: "Tab6",
            label: "تطبيقات الجوال المخصصة للشركات الناشئة",
            content:
                "تحتاج الشركات الناشئة إلى تطبيقات جوال سريعة وقابلة للتطوير وفعالة من حيث التكلفة للتميز في سوق اليوم التنافسي. تم تصميم خدمات تطوير تطبيقات الجوال التي تركز على الشركات الناشئة لدينا لتحويل الأفكار المبتكرة إلى تطبيقات عالية الأداء تدفع النمو. نحن متخصصون في بناء الحد الأدنى من المنتجات القابلة للتطبيق (MVPs) التي تساعد الشركات الناشئة على الإطلاق بسرعة، وجمع ملاحظات المستخدمين، وتحسين عروضها.",
            secondContent: "من خلال الاستفادة من التقنيات المتقدمة ورؤى السوق، نضمن أن يكون تطبيقك مقاومًا للمستقبل، وقابلًا للتكيف، وجاهزًا للتوسع مع نمو عملك. من الفكرة والنموذج الأولي إلى التطوير والنشر على نطاق واسع، نقدم حلولًا شاملة تساعد الشركات الناشئة على تحقيق رؤيتها وتعظيم إمكاناتها السوقية. بفضل خبرتنا في التطوير السريع، والمنهجيات المرنة، والحلول الفعالة من حيث التكلفة، نضمن أن يقدم تطبيقك قيمة حقيقية ونجاحًا طويل الأمد.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/mobile-app-development/swiftui.png",
                },
                {
                    img: "/images/services-icons/mobile-app-development/jetpack compose icon_RGB.png",
                },
                {
                    img: "/images/services-icons/mobile-app-development/Google-flutter-logo.png",
                },
            ],
        },
        {
            id: "Tab7",
            label: "صيانة ودعم تطبيقات الجوال",
            content:
                "إطلاق تطبيق جوال هو مجرد البداية. للحفاظ على تشغيل تطبيقك بسلاسة وأمان، تعد الصيانة والدعم المستمران ضروريين. نقدم خدمات شاملة ما بعد الإطلاق لضمان أن يظل تطبيقك محدثًا، وخاليًا من الأخطاء، ومحسنًا للأداء.",
            secondContent: "تشمل خدمات الصيانة لدينا تحديثات منتظمة، وتصحيحات أمنية، ومراقبة الأداء، وتحسينات الميزات، وتحليل سلوك المستخدم. نحدد المشكلات المحتملة بشكل استباقي ونحلها قبل أن تؤثر على تجربة المستخدم. سواء كان الأمر يتعلق بالتكيف مع تحديثات نظام التشغيل الجديدة، أو تحسين أداء التطبيق، أو تنفيذ ميزات جديدة، فإننا نضمن أن يظل تطبيقك موثوقًا وآمنًا وتنافسيًا في المشهد الرقمي دائم التطور.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/mobile-app-development/swiftui.png",
                },
                {
                    img: "/images/services-icons/mobile-app-development/jetpack compose icon_RGB.png",
                },
                {
                    img: "/images/services-icons/mobile-app-development/Google-flutter-logo.png",
                },
            ],
        },
    ]
}

export const mobileAppTypesOfBuildDataArabic = {
    mainHeading: "أنواع تطبيقات الجوال التي نبنيها.",
    accordianData: [
        {
            id: "collapseOne",
            question: "التطبيقات الأصلية (Native Apps)",
            answer: {
                discription:
                    "تطبيقات iOS و android الأصلية هي جوهر خدماتنا لتطوير تطبيقات الجوال. نحن نطور تطبيقات أصلية عالية الأداء توفر تجربة مستخدم بديهية وسلسة.",
                listTitle: "تطبيقاتنا الأصلية للجوال هي الأفضل لـ:",
                listContent: [
                    {
                        line: "تطبيقات الجوال المعقدة",
                    },
                    {
                        line: "الأداء العالي وواجهة المستخدم السلسة",
                    },
                    {
                        line: "التطبيقات التي تتطلب معالجة بيانات مكثفة",
                    },
                    {
                        line: "التطبيقات الحساسة للأمان",
                    },
                    {
                        line: "التطبيقات التي تتطلب ميزات الجهاز",
                    },
                ],
            },
        },
        {
            id: "collapseTwo",
            question: "التطبيقات متعددة المنصات (Cross-Platform Apps)",
            answer: {
                discription:
                    "بدلاً من تطوير تطبيقين أصليين للجوال، احصل على تطبيق متعدد المنصات عملي بين iOS و android في نفس الوقت. لذلك، لكل عقبة قد يواجهها عميلك، فقد قمنا بتغطيتك بالفعل من خلال خدمات تطوير التطبيقات المخصصة لدينا.",
                listTitle: "تطبيقاتنا متعددة المنصات هي الأفضل لـ:",
                listContent: [
                    {
                        line: "التطوير السريع ووقت الوصول إلى السوق",
                    },
                    {
                        line: "الوصول إلى مستخدمي iOS و android بقاعدة تعليمات برمجية واحدة",
                    },
                    {
                        line: "التطوير والصيانة الفعالة من حيث التكلفة",
                    },
                    {
                        line: "التطبيقات ذات الوظائف الأساسية إلى المتوسطة",
                    },
                    {
                        line: "التطبيقات التي تستهدف منصات متعددة بأقل عبء أداء",
                    },
                    {
                        line: "المشاريع ذات الموارد المحدودة أو الميزانيات الأصغر",
                    },
                ],
            },
        },
        {
            id: "collapseThree",
            question: "التطبيقات الهجينة (Hybrid Apps)",
            answer: {
                discription:
                    "باستخدام موارد الويب، يمكن لمطورينا بناء تطبيقات شبيهة بالتطبيقات الأصلية لمستخدمي الهاتف المحمول. خدمات تطوير التطبيقات الهجينة لدينا هي الحل الأمثل للحلول سريعة البناء.",
                listTitle: "التطبيقات الهجينة هي الأفضل لـ:",
                listContent: [
                    {
                        line: "تطبيقات الجوال البسيطة ذات الوظائف الأساسية",
                    },
                    {
                        line: "التطوير والنشر السريع عبر منصات متعددة",
                    },
                    {
                        line: "التطبيقات ذات الاعتماد المحدود أو بدون اعتماد على ميزات خاصة بالجهاز",
                    },
                    {
                        line: "المشاريع ذات الميزانية أو الجدول الزمني المحدود",
                    },
                    {
                        line: "التطبيقات التي تحتاج إلى استهداف قاعدة مستخدمين واسعة على كل من iOS و android",
                    },
                    {
                        line: "التطبيقات المعتمدة على المحتوى (مثل الأخبار، المدونات، الوسائط)",
                    },
                ],
            },
        },
        {
            id: "fourth",
            question: "تطبيقات الأجهزة القابلة للارتداء (Wearables Apps)",
            answer: {
                discription:
                    "سواء كانت ساعة ذكية أو سماعة رأس للواقع الافتراضي، فإن تطبيقاتنا للأجهزة القابلة للارتداء هي الحل الوحيد. نحن نقدم خدمات تطوير التطبيقات لكل جهاز ذكي، باستخدام تصميمات الهياكل الشبكية وميزات الواقع المعزز.",
                listTitle: "تطبيقات الأجهزة القابلة للارتداء هي الأفضل لـ:",
                listContent: [
                    {
                        line: "تطبيقات الجوال المعقدة",
                    },
                    {
                        line: "الأداء العالي وواجهة المستخدم السلسة",
                    },
                    {
                        line: "التطبيقات التي تتطلب معالجة بيانات مكثفة",
                    },
                    {
                        line: "التطبيقات الحساسة للأمان",
                    },
                    {
                        line: "التطبيقات التي تتطلب ميزات الجهاز",
                    },
                ],
            },
        },
    ]
}

export const mobileAppWhoWeServeDataArabic = {
    mainHeading: "من نخدم",
    sectionDescription: "خدماتنا لتطوير تطبيقات الهاتف المحمول لا تقتصر على أي مستوى من النجاح، بل ننطلق من حيث أنت ونقدم أعلى مستوى من الانتصار الابتكاري.",
    cardsData: [
        {
            icon: "/images/servie-icon/startups.svg",
            title: "الشركات الناشئة",
            description:
                "نحن متحمسون دائمًا للعمل مع الشركات الناشئة، ونقدم لهم الانطلاقة التي يحتاجونها ونبني علاقات طويلة الأمد.",
            link: "#",
            borderClass: "border-1",
        },
        {
            icon: "/images/servie-icon/company.png",
            title: "شركات المنتجات البرمجية",
            description:
                "بالنسبة لشركات المنتجات البرمجية، نقدم خدمات تطوير تطبيقات الهاتف المحمول الشاملة التي تعزز قيمة منتجك، وتحسن تجربة العملاء، وتدعم التكامل السلس مع الأنظمة الحالية.",
            link: "#",
            borderClass: "border-2",
        },
        {
            icon: "/images/servie-icon/industries.svg",
            title: "المؤسسات من 30+ صناعة",
            description:
                "نتعاون مع المؤسسات عبر أكثر من 30 صناعة، بما في ذلك التمويل والرعاية الصحية والتجزئة والتعليم والخدمات اللوجستية والمزيد. تمتد خبرتنا إلى تطوير تطبيقات الهاتف المحمول المخصصة المصممة لتلبية التحديات الخاصة بالصناعة، ودفع تحول الأعمال، وتقديم نتائج قابلة للقياس على نطاق واسع. نحن نفهم الاحتياجات الفريدة لكل قطاع ونعمل معك لإنشاء حلول لا تلبي أهدافك فحسب، بل تتجاوز التوقعات أيضًا.",
            link: "#",
            borderClass: "border-3",
        },
    ]
}

export const mobileAppWhyChoseUsArabic = {
    mainHeading: "لماذا تختار Bitsclan كشركة تطوير تطبيقات الهاتف المحمول الخاصة بك؟",
    sectionDescription: "من تطوير تطبيقات iOS إلى خدمات تطوير تطبيقات android، تقدم Bitsclan تجربة سلسة للخدمات التي يمكن دمجها في الحلول الحالية، وخالية من العيوب بعد النشر وآمنة بنفس القدر أثناء العمل.",
    tabsData: [
        {
            id: "Tab1",
            label: "الجودة لأنها مهمة",
            content:
                "نحن نعطي الأولوية للجودة العالية في كل مرحلة، مما يضمن تطبيقات قوية وعالية الأداء توفر تجارب مستخدم استثنائية.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
        {
            id: "Tab2",
            label: "أفضل المواهب من نوعها",
            content:
                "يتكون فريقنا من محترفين مهرة خبراء في أحدث التقنيات، ويصنعون حلولًا مبتكرة وموثوقة للهواتف المحمولة.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
        {
            id: "Tab3",
            label: "توافق المنطقة الزمنية",
            content:
                "يضمن تواجدنا العالمي تعاونًا سلسًا، مع توافق المنطقة الزمنية الذي يحافظ على مشروعك في المسار الصحيح، بغض النظر عن مكان وجودك.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
        {
            id: "Tab4",
            label: "دعم ما بعد النشر",
            content:
                "نقدم دعمًا شاملاً بعد الإطلاق، مما يضمن بقاء تطبيقك محدثًا وآمنًا ومحسنًا للنجاح على المدى الطويل.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
        {
            id: "Tab5",
            label: "حلول فعالة من حيث التكلفة",
            content:
                "نقدم تطبيقات جوال عالية الجودة بأسعار تنافسية، مما يضمن حصولك على أفضل قيمة لاستثمارك دون المساومة على الجودة.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
    ]
}

export const mobileAppHighvaluesDataArabic = {
    mainHeading: "ميزات عالية القيمة لتطبيقات عالية الأداء",
    sectionDescription: "في بيتسكلان، نؤمن بالحلول عالية التقنية بدون أي تنازلات، وهذا ما ساعدنا على صعود سلم النجاح في هذا العصر التنافسي. نساعدك على إطلاق العنان للإمكانات الحقيقية لمشاريعك بميزات نوعية تقدم حلولًا مخصصة.",
    buttonText: "استشر نطاق المشروع",
    highValueCards: [
        {
            image: "custom-app-development.svg",
            text: "تطوير تطبيقات مخصصة",
        },
        {
            image: "user-centric-designs.svg",
            text: "تصاميم تركز على المستخدم",
        },
        {
            image: "robust-architecture.svg",
            text: "بنية قوية",
        },
        {
            image: "efficient-integration.svg",
            text: "تكامل فعال",
        },
        {
            image: "advanced-analytics.svg",
            text: "تحليلات متقدمة",
        },
        {
            image: "enhanced-security.svg",
            text: "أمان معزز",
        },
        {
            image: "agile-methodology.svg",
            text: "منهجية Agile",
        },
        {
            image: "cross-platform-support.svg",
            text: "دعم عبر المنصات",
        },
        {
            image: "ongoing-maintenance.svg",
            text: "صيانة مستمرة",
        },
        {
            image: "innovation-driven-features.svg",
            text: "ميزات مدفوعة بالابتكار",
        },
    ]
}

export const mobileAppRoadMapHeadingsArabic = {
    mainHeading: "خارطة طريقنا المُثبتة لضمان نجاحك",
    sectionDescription: "بصفتنا مزودًا رائدًا لخدمات تطوير تطبيقات الذكاء الاصطناعي، فقد قمنا بتطوير خارطة طريق منظمة لضمان نجاح مشاريعك. من الفكرة الأولية إلى الدعم المستمر، نتبع نهجًا منهجيًا يضمن التوافق مع أهداف عملك، ويقدم حلولًا عالية الجودة، ويوفر تحسينًا مستمرًا. إليك كيف نقوم بذلك:"
}

export const mobileAppCoverTheStackArabic = {
    mainHeading: "قم بتحسين تطوير تطبيقات الهاتف المحمول باستخدام حزمة التكنولوجيا الرائدة",
    sectionDescription:
        "في Bitsclan، نضمن أن تكون عمليات تطوير تطبيقات الهاتف المحمول لديك مدعومة بأحدث التقنيات المتاحة. تم اختيار حزمة التكنولوجيا لدينا بعناية لزيادة الكفاءة والأمان وقابلية التوسع في كل مرحلة من مراحل دورة حياة تطوير البرمجيات.",
    defaultOpenTab: "الواجهة الأمامية",
    tabs: [
        "الواجهة الأمامية",
        "الواجهة الخلفية",
        "قاعدة البيانات",
        "الأطر",
        "ديف أوبس",
        "أدوات الهاتف المحمول",
    ],

    tabItems: [
        // تقنيات الواجهة الأمامية لتطوير تطبيقات الهاتف المحمول
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/react.svg", name: "React Native" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/Flutter.svg", name: "Flutter" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/Ionic.svg", name: "Ionic" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/swift.svg", name: "Swift" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/kotlin.svg", name: "Kotlin" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/xamarin.svg", name: "Xamarin" },

        // تقنيات الواجهة الخلفية
        { tab: "الواجهة الخلفية", icon: "/images/database9.png", name: "Node.js" },
        { tab: "الواجهة الخلفية", icon: "/images/django-tech.svg", name: "Django" },
        { tab: "الواجهة الخلفية", icon: "/images/database8.png", name: "PHP" },
        { tab: "الواجهة الخلفية", icon: "/images/database5.png", name: "Express.js" },
        { tab: "الواجهة الخلفية", icon: "/images/database6.png", name: "Python" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/dart.svg", name: "Dart" },

        // تقنيات قواعد البيانات
        { tab: "قاعدة البيانات", icon: "/images/db1.png", name: "Firebase" },
        { tab: "قاعدة البيانات", icon: "/images/db5.png", name: "MySQL" },
        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/postgres.svg", name: "PostgreSQL" },
        { tab: "قاعدة البيانات", icon: "/images/db3.png", name: "MongoDB" },

        // الأطر المستخدمة
        { tab: "الأطر", icon: "/images/tech-stack-icons/visualstudio.svg", name: "Visual Studio" },
        { tab: "الأطر", icon: "/images/tech-stack-icons/Android-Studio.webp", name: "Android Studio" },

        // أدوات ديف أوبس
        { tab: "ديف أوبس", icon: "/images/devops1.png", name: "Gradle" },
        { tab: "ديف أوبس", icon: "/images/devops2.png", name: "Kubernetes" },
        { tab: "ديف أوبس", icon: "/images/devops3.png", name: "Docker" },
        { tab: "ديف أوبس", icon: "/images/devops4.png", name: "Jenkins" },

        // أدوات تطوير الهاتف المحمول
        { tab: "أدوات الهاتف المحمول", icon: "/images/tech-stack-icons/cordova.svg", name: "Cordova" },
        { tab: "أدوات الهاتف المحمول", icon: "/images/tech-stack-icons/Phone.svg", name: "Phone Gap" },
        { tab: "أدوات الهاتف المحمول", icon: "/images/tech-stack-icons/ios.svg", name: "iOS" },
    ],
};

export const mobileAppIndustriesHeadingArabic = {
    mainHeading: "الصناعات التي نخدمها تطوير الهاتف المحمول"
}

export const frequentlyAskedQuestionDataArabic = {
    mainHeading: "الأسئلة الشائعة",
    sectionDescription: "احصل على إجابات سريعة لأسئلتك حول عملية وخدمات تطوير تطبيقات الهاتف المحمول لدينا.",
    questionAnswer: [
        {
            id: "collapseOne",
            question: "ما هي خدمات تطوير تطبيقات الهاتف المحمول؟",
            answer:
                "تغطي خدمات تطوير تطبيقات الهاتف المحمول كل شيء بدءًا من التصميم والبرمجة وصولًا إلى اختبار وإطلاق تطبيقات الهاتف المحمول. تشمل هذه الخدمات تصميم واجهة المستخدم/تجربة المستخدم، وتطوير الواجهة الخلفية، وتحسينات الأمان، والصيانة بعد الإطلاق. يمكن بناء التطبيقات لأنظمة iOS أو android أو كليهما باستخدام حلول متعددة المنصات.",
        },
        {
            id: "collapseTwo",
            question: "ما هي تكلفة تطوير تطبيق هاتف محمول؟",
            answer:
                "تعتمد تكلفة تطوير تطبيق الهاتف المحمول على عوامل مثل الميزات والمنصة (iOS أو android أو كليهما) والتعقيد ووقت التطوير. يمكن أن تتراوح من بضعة آلاف إلى مئات الآلاف من الدولارات، اعتمادًا على متطلبات المشروع.",
        },
        {
            id: "collapseThree",
            question: "كم يستغرق تطوير تطبيق هاتف محمول؟",
            answer:
                "يختلف الجدول الزمني للتطوير بناءً على تعقيد التطبيق وميزاته وحجم الفريق. قد تستغرق التطبيقات البسيطة من 3 إلى 6 أشهر، بينما يمكن أن تستغرق الحلول المعقدة ذات الوظائف المتقدمة عامًا أو أكثر.",
        },
        {
            id: "fourth",
            question: "كيف يمكنني اختيار شركة لتطوير تطبيقات الهاتف المحمول؟",
            answer:
                "ابحث عن شركة ذات سجل أعمال قوي، وخبرة في مجال عملك، وخبرة في تقنيات الهاتف المحمول. تحقق من مراجعات العملاء، وقيم التواصل، وتأكد من أنها تقدم دعمًا بعد الإطلاق.",
        },
        {
            id: "fifth",
            question: "كيف يمكنني تتبع تقدم تطبيقي؟",
            answer:
                "يقدم فريق التطوير الجيد تحديثات منتظمة، ومراحل المشروع، وإصدارات تجريبية. يضمن استخدام أدوات إدارة المشاريع والاجتماعات المجدولة الشفافية طوال عملية التطوير.",
        },
        {
            id: "sixth",
            question: "هل تعملون مع التطبيقات الحساسة للأمان؟",
            answer:
                "نعم، نقوم بتطوير تطبيقات بمعايير أمان عالية، بما في ذلك التشفير، والمصادقة الآمنة، والامتثال للوائح الصناعة. نضمن حماية البيانات لتطبيقات الخدمات المصرفية والرعاية الصحية والمؤسسات.",
        },
    ]
}